// @vendors
import React, { useContext, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  Button,
  ClearAllIcon,
  IconButton,
  TextField,
  Tooltip,
  Grid,
  Box,
  Link,
} from "../../../../components/shared/MaterialUI";

// @assets
import { EmployeeTableStyles } from '../../../../assets/css/employeeTable-style';
import { theme } from '../../../../assets/theme';
import { GeneralStyles } from '../../../../assets/css/general-style';

// @context
import { EmployeeContext } from '../../Employer';

// @constants
import { ROUTENAME } from '../../../../navigation/RouteName';

// @components
import MenuAddBranch from './MenuAddBranch';

// @helpers
import { downloadEmployees, isRyzeOrganization, permissionsForEditEmployer } from '../../../../helpers/FunctionsUtils';
import { useUI } from '../../../../app/context/ui';

const ToolbarChild = () => {
    const styleEmployee = useMemo(() => EmployeeTableStyles(),[]);
    const generalStyle = useMemo(() => GeneralStyles(), []);
    const history = useHistory();
    const {
        setShowChildrens,
        getAllEmployesByCompany,
        getAllChildrens,
        employerDetails,
        setRowsState,
        companyId,
        listChildrens,
        setListChildrens,
        setTextEmptyChild,
        setSearchChildren,
        searchChildren
    } = useContext(EmployeeContext);
    const [anchorElMenu, setAnchorElMenu] = useState(null);
    const openMenu = Boolean(anchorElMenu);
    const globalState = useSelector((state) => state);
    const organization = globalState?.organizationReducer?.organizationSelected;
    const user = globalState?.user;
    const { blockUI, snackbarUI } = useUI();

    const handleClickMenu = (event) => {
        setAnchorElMenu(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorElMenu(null);
    };

    const showEmployeesByCompany = () => {
        clearSearch();
        setRowsState((prev) => ({
            ...prev,
            pageSize: 10,
            rows: [],
            rowCount: 0,
            currentPage: 0,
            page: 0,
            filters: { name: '', status: '' },
        }));
        setShowChildrens(false);
        getAllEmployesByCompany({companyId:companyId, filters: {}});
    }

    /* search bar */

    const clearSearch = () => {
        setSearchChildren('');
        setTextEmptyChild(false);
        setListChildrens({...listChildrens, rows: listChildrens?.rowList});
    }

    const onChangeSearch = (e) => {
        setTextEmptyChild(false);
        const value = e.target.value;
        const transformValue = value?.toLowerCase();
        const list = listChildrens?.rowList?.filter((item) =>  item?.name?.toLowerCase()?.includes(transformValue));
        setSearchChildren(value);
        if(!list.length) setTextEmptyChild(true);
        setListChildrens((prev) => ({...prev, rows: list }));
    }

  return (
    <Box sx={styleEmployee.tableToolbar}>
        <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
        >
            <Grid item xs={12} sm={4} md={3} lg={2}>
                <h2
                    style={{
                        textAlign: 'start',
                        fontSize: '1.5rem',
                        color: theme.palette.primary.black
                    }}
                >
                    Children list
                </h2>        
            </Grid>

            <Grid
                item xs={12} sm={8} md={9} lg={5}
                sx={{display: 'flex', gap: '10px', alignItems: 'center'}}
            >
                <TextField
                    sx={{...styleEmployee.searchInput, ...generalStyle.customButtonSm, padding: 0}}
                    value={searchChildren}
                    id="searchbar"
                    placeholder="Search"
                    onChange={(e) => onChangeSearch(e)}
                    variant="outlined"
                />
                <Tooltip title="Clear filter">
                    <IconButton
                        onClick={() => clearSearch()}
                        sx={generalStyle.iconButtonSearch}
                    >
                        <ClearAllIcon />
                    </IconButton>
                </Tooltip>
            </Grid>

            {!isRyzeOrganization(organization) && permissionsForEditEmployer(user?.role) &&
                <Grid item xs={12} sm={6} md={4} lg={2.5}>
                    <Button
                        variant="contained"
                        sx={{
                            ...generalStyle.customButton,
                            ...generalStyle.customButtonSm,
                            pointerEvents: isRyzeOrganization(organization) ? 'none' : 'auto'
                        }}
                        onClick={handleClickMenu}
                        aria-controls={openMenu ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? 'true' : undefined}
                    >
                        Add new branch
                    </Button>
                </Grid>
            }

            {employerDetails?.data?.mainParentCompanyId &&
                <Grid item xs={12} sm={6} md={4} lg={2.5}>
                    <Button
                        variant='contained'
                        sx={{...generalStyle.customButton, ...generalStyle.customButtonSm}}
                        onClick={() => {
                            clearSearch();
                            history.push(`${ROUTENAME.employer}${employerDetails?.data?.mainParentCompanyId}`);
                            getAllChildrens(employerDetails.data.mainParentCompanyId);
                        }}
                    >
                        back to main parent
                    </Button>
                </Grid>
            }
            
            {employerDetails?.data?.parentCompanyId &&
                <Grid item xs={12} sm={6} md={4} lg={2.5}>
                    <Button
                        variant='contained'
                        sx={{...generalStyle.customButton, ...generalStyle.customButtonSm}}
                        onClick={() => {
                            clearSearch();
                            history.push(`${ROUTENAME.employer}${employerDetails?.data?.parentCompanyId}`)
                            getAllChildrens(employerDetails.data.parentCompanyId)
                        }}
                    >
                        back to parent
                    </Button>
                </Grid>
            }

            <Grid item xs={12} sm={6} md={4} lg={2.5}>
                <Button
                    variant='contained'
                    sx={{...generalStyle.customButton, ...generalStyle.customButtonSm}}
                    onClick={() => showEmployeesByCompany()}
                >
                    show employees
                </Button>
            </Grid>

            {!isRyzeOrganization(organization) &&
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Tooltip title="Export employees">
                        <Link
                            download
                            onClick={() => downloadEmployees(companyId, blockUI, snackbarUI)}
                            sx={styleEmployee.exportLink}
                        >
                        <Button
                            variant="contained"
                            component="span"
                            sx={{...generalStyle.customButton, ...generalStyle.customButtonSm}}
                        >
                            Export
                        </Button>
                        </Link>
                    </Tooltip>
                </Grid>
            }

            <MenuAddBranch 
                anchorElMenu={anchorElMenu}
                openMenu={openMenu}
                handleCloseMenu={handleCloseMenu}
            />
        </Grid>
    </Box>
  )
}

export default ToolbarChild